export default __webpack_public_path__ + "static/media/gear.59fb6317.svg";